import { getMe } from "@/graphql/queries";

export const me = {
  apollo: {
    me: {
      query: getMe,
      update: data => ({...data.me, file: []})
    }
  }
};
